// third party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import githubReducer from './slices/github';
import jiraReducer from './slices/jira';
import asanaReducer from './slices/asana';
import confluenceReducer from './slices/confluence';
import notionReducer from './slices/notion';
import gitlabReducer from './slices/gitlab';
import projectsReducer from './slices/projects';
import repositoriesReducer from './slices/repositories';
import tasksReducer from './slices/tasks';
import pullRequestsReducer from './slices/pull-requests';
import integrationsReducer from './slices/integrations';
import usersReducer from './slices/users';
import authReducer from './slices/auth';
import organizationsReducer from './slices/organizations';
import analyticsReducer from './slices/analytics';
import aiModelsReducer from './slices/ai-models';
import activityReducer from './slices/activity';
import healthReducer from './slices/health';
import subscriptionsReducer from './slices/subscriptions';
import pricingReducer from './slices/pricing';
import knowledgeBaseReducer from './slices/knowledge-base';
import repositoryKnowledgeBaseReducer from './slices/repository-knowledge-base';
import repositoryAgentWorkReducer from './slices/repository-agent-work';
import insightsReducer from './slices/insights';
import chatReducer from './slices/chat';

// ==============================|| PERSIST CONFIGS ||============================== //

const authPersistConfig = {
  key: 'auth',
  version: 1,
  storage,
  whitelist: ['isAuthenticated', 'user', 'accessToken', 'refreshToken'],
};

const organizationsPersistConfig = {
  key: 'organizations',
  version: 1,
  storage,
  whitelist: ['currentOrganization', 'selectedOrganizationId'],
};

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  github: githubReducer,
  jira: jiraReducer,
  asana: asanaReducer,
  confluence: confluenceReducer,
  notion: notionReducer,
  gitlab: gitlabReducer,
  projects: projectsReducer,
  repositories: repositoriesReducer,
  tasks: tasksReducer,
  pullRequests: pullRequestsReducer,
  integrations: integrationsReducer,
  users: usersReducer,
  analytics: analyticsReducer,
  aiModels: aiModelsReducer,
  activity: activityReducer,
  health: healthReducer,
  subscriptions: subscriptionsReducer,
  pricing: pricingReducer,
  knowledgeBase: knowledgeBaseReducer,
  repositoryKnowledgeBase: repositoryKnowledgeBaseReducer,
  repositoryAgentWork: repositoryAgentWorkReducer,
  insights: insightsReducer,
  chat: chatReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  organizations: persistReducer(organizationsPersistConfig, organizationsReducer),
});

export default reducer;
